// Definitions of status transitions
// used to determine the new status for a CRQ
// and any WIIs that should be created
import {
  getIsOlaCrq,
  isCrqEmergency,
  // currentSelectedNetwork,
  // userRoleForSelectedNetwork,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { CRQ_STATUSES } from './crq-statuses';

// creation of a new crq.
// Either as a requester on submit, or a coordinator during the raise crq flow
const RAISE_CRQ = 'RAISE_CRQ';
// Coordinator approves a CRQ from coordinator review
// and submits it to peer review
const SUBMIT_TO_PEER_REVIEW = 'SUBMIT_TO_PEER_REVIEW';
// Submit to l3 approvals
const SUBMIT_TO_L3_APPROVALS = 'SUBMIT_TO_L3_APPROVALS';
// Coordinator cancels a CRQ from coordinator review
const CANCEL_CRQ = 'CANCEL_CRQ';
// From peer review to scheduled cancels a CRQ
const CANCEL_ACTION_CRQ = 'CANCEL_ACTION_CRQ';

const POSTPONE_CRQ = 'POSTPONE_CRQ';
// peer reviewer approves CRQ from peer review
// and submits CRQ to approval
const SUBMIT_TO_APPROVALS = 'SUBMIT_TO_APPROVALS';
// coordinator approves CRQ from coordinator review
// and submits crq to approval
const OLO_SUBMIT_TO_APPROVALS = 'OLO_SUBMIT_TO_APPROVALS';
// peer reviewer rejects CRQ from peer review
const REJECT_FROM_PEER_REVIEW = 'REJECT_FROM_PEER_REVIEW';
// An approver has added their signature to the approval list.
// transition is handled by the server here, not us
const APPROVED_FROM_APPROVALS = 'APPROVED_FROM_APPROVALS';
// An approver has rejected with their signature.
// transition is handled by the server here, not us
const REJECTED_FROM_APPROVALS = 'REJECTED_FROM_APPROVALS';
// Coordinator closes a CRQ from completion review.
// transition is handled by the server here, not us
const CLOSE_CRQ = 'CLOSE_CRQ';
// Coordinator closes a OLO CRQ from completion review.
const CLOSE_OLO_CRQ = 'CLOSE_OLO_CRQ';

const SCHEDULED_FOR_APPROVAL = 'SCHEDULED_FOR_APPROVAL';
// Approvers can revoke the approval granted to CRQ in Approvals stage.
const REVOKE_APPROVAL = 'REVOKE_APPROVAL';

const COMPLETED = 'COMPLETED';
const CLOSED = 'CLOSED';
const CRQ_STATUS_TRANSITIONS = {
  // creation of a new crq.
  // As a requester this is on submit
  raiseCrq: {
    id: RAISE_CRQ,
    targetStatus: CRQ_STATUSES.coordinator,
  },
  submitToPeerReview: {
    id: SUBMIT_TO_PEER_REVIEW,
    targetStatus: CRQ_STATUSES.peerReview,
  },
  submitToL3Approval: {
    id: SUBMIT_TO_L3_APPROVALS,
    targetStatus: CRQ_STATUSES.peerReview,
  },
  cancelCrq: {
    id: CANCEL_CRQ,
    targetStatus: CRQ_STATUSES.cancelled,
  },
  closeCrq: {
    id: CLOSE_CRQ,
    targetStatus: CRQ_STATUSES.closed,
  },
  closeOLOCrq: {
    id: CLOSE_OLO_CRQ,
    targetStatus: CRQ_STATUSES.closed,
  },
  cancelActionCrq: {
    id: CANCEL_ACTION_CRQ,
    targetStatus: CRQ_STATUSES.cancelled,
  },
  postponeCrq: {
    id: POSTPONE_CRQ,
    targetStatus: CRQ_STATUSES.coordinator,
  },
  submitToApproval: {
    id: SUBMIT_TO_APPROVALS,
    // The system does not want us to upsert the crq with the new status of `approvals`
    // Instead that happens automatically when the WII is created. As such we set the target
    // status to `peerReivew` which is the same as the initial status
    targetStatus: CRQ_STATUSES.peerReview,
  },
  oloSubmitToApproval: {
    id: OLO_SUBMIT_TO_APPROVALS,
    // The system does not want us to upsert the crq with the new status of `approvals`
    // Instead that happens automatically when the WII is created. As such we set the target
    // status to `peerReivew` which is the same as the initial status
    targetStatus: CRQ_STATUSES.peerReview,
  },
  rejectFromPeerReview: {
    id: REJECT_FROM_PEER_REVIEW,
    // The system does not want us to upsert the crq with the new status of `coordinator`
    // Instead that happens automatically when the rejection WII is created. As such we set the target
    // status to `peerReivew` which is the same as the initial status
    targetStatus: CRQ_STATUSES.peerReview,
  },
  oloSubmitRejectApproval: {
    id: SCHEDULED_FOR_APPROVAL,
    targetStatus: CRQ_STATUSES.approvals,
  },

  Completed: {
    id: COMPLETED,
    targetStatus: CRQ_STATUSES.completed,
  },

  Closed: {
    id: CLOSED,
    targetStatus: CRQ_STATUSES.closed,
  },

  revokeApproval: {
    id: REVOKE_APPROVAL,
    targetStatus: CRQ_STATUSES.approvals,
  },
};

const getFowardTransition = (params = {}) => {
  const {
    currentStatus,
    formData,
    statusReasonValue,
    isEmergency2ndJourney,
  } = params;

  // const isOlaCrq = getIsOlaCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const completionReview = 'COMPLETION_REVIEW';
  // const ccn = 'actual_end_date';
  const isOloByService = formData ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  const isOlaCrq = getIsOlaCrq(formData) || isOloByService;
  const isFailure = formData.dataByFormSectionId[completionReview] && formData.dataByFormSectionId[completionReview].fieldIdsByDisplayOrder.some((items) => items.includes('change-coordinator-name'));
  // to handle some scenarios for L3 approvar routing nd confirmation
  const isEmergency = isCrqEmergency(formData);
  if (currentStatus === CRQ_STATUSES.coordinator && !isEmergency) {
    return CRQ_STATUS_TRANSITIONS.submitToPeerReview;
  }
  if (currentStatus === CRQ_STATUSES.coordinator && isEmergency) {
    return CRQ_STATUS_TRANSITIONS.submitToL3Approval;
  }
  if (currentStatus === CRQ_STATUSES.coordinator && isOlaCrq && !isEmergency) {
    return CRQ_STATUS_TRANSITIONS.submitToPeerReview;
  }
  if (currentStatus === CRQ_STATUSES.coordinator && isOlaCrq && isEmergency) {
    return CRQ_STATUS_TRANSITIONS.submitToPeerReview;
  }
  if (currentStatus === CRQ_STATUSES.coordinator && isEmergency && isEmergency2ndJourney) {
    return CRQ_STATUS_TRANSITIONS.submitToApproval;
  }
  if (currentStatus === CRQ_STATUSES.peerReview) {
    return CRQ_STATUS_TRANSITIONS.submitToApproval;
  }
  if (currentStatus === CRQ_STATUSES.approvals) {
    return CRQ_STATUS_TRANSITIONS.oloSubmitRejectApproval;
  }
  if (currentStatus === CRQ_STATUSES.implementation) {
    return CRQ_STATUS_TRANSITIONS.Completed;
  }
  // below block is for scenario when status is completed - unsuccsessfull & failure review is required
  if (currentStatus === CRQ_STATUSES.completed && isFailure === true) {
    return CRQ_STATUS_TRANSITIONS.Closed;
  }
  // below block is for scenario when status is completed - unsuccsessfull & failure review is required
  if (currentStatus === CRQ_STATUSES.completed && (statusReasonValue === 'Successful' || statusReasonValue === '5000')) {
    return CRQ_STATUS_TRANSITIONS.Closed;
  }
  // below block for status is completed - successfull & its needs to be change to completed - unsuccessfull
  if (currentStatus === CRQ_STATUSES.completed && isFailure === false) {
    return CRQ_STATUS_TRANSITIONS.Completed;
  }
  // There is no safe fallback for this. If we don't know the correct transition to set for a CRQ
  // we could break the CRQ by setting an incorrect status. As such, we just crash!
  throw new Error(`Unable to find foward transition for currentStatus: ${currentStatus}`);

};

const getBackwardTransition = (params = {}) => {
  const {
    currentStatus,
    isShowCrqAction,
    crqActionIspostponeOrCancel,
    isEmergency,
  } = params;

  if (currentStatus === CRQ_STATUSES.coordinator) {
    return CRQ_STATUS_TRANSITIONS.cancelCrq;
  }

  if (currentStatus === CRQ_STATUSES.peerReview && isEmergency) {
    return CRQ_STATUS_TRANSITIONS.postponeCrq;
  }

  if ((currentStatus === CRQ_STATUSES.peerReview || currentStatus === CRQ_STATUSES.approvals || currentStatus === CRQ_STATUSES.scheduled || currentStatus === CRQ_STATUSES.implementation) && isShowCrqAction && (crqActionIspostponeOrCancel === 'Cancel')) {
    return CRQ_STATUS_TRANSITIONS.cancelActionCrq;
  }

  if ((currentStatus === CRQ_STATUSES.peerReview || currentStatus === CRQ_STATUSES.approvals || currentStatus === CRQ_STATUSES.scheduled) && isShowCrqAction && (crqActionIspostponeOrCancel === 'Postpone')) {
    return CRQ_STATUS_TRANSITIONS.postponeCrq;
  }

  if ((currentStatus === CRQ_STATUSES.peerReview) && !isShowCrqAction) {
    return CRQ_STATUS_TRANSITIONS.rejectFromPeerReview;
  }

  // There is no safe fallback for this. If we don't know the correct transition to set for a CRQ
  // we could break the CRQ by setting an incorrect status. As such, we just crash!
  throw new Error(`Unable to find backward transition for currentStatus: ${currentStatus}`);

};

const statusTransitionsThatShouldSkipPostCrq = [
  SUBMIT_TO_APPROVALS,
  OLO_SUBMIT_TO_APPROVALS,
  REJECT_FROM_PEER_REVIEW,
  REVOKE_APPROVAL,
];

// does upsertCrq need to be called based on the status transition
// some status transitions (e.g peerApproval) do not require upsertCrq
const shouldStatusTransitionSkipPostCrq = (statusTransition) => {
  if (!statusTransition) return false;
  return statusTransitionsThatShouldSkipPostCrq.includes(statusTransition.id);
};

export {
  CRQ_STATUS_TRANSITIONS,
  RAISE_CRQ,
  SUBMIT_TO_PEER_REVIEW,
  SUBMIT_TO_L3_APPROVALS,
  CANCEL_CRQ,
  CLOSE_CRQ,
  CLOSE_OLO_CRQ,
  SUBMIT_TO_APPROVALS,
  CANCEL_ACTION_CRQ,
  POSTPONE_CRQ,
  // SUBMIT_TO_APPROVALS,
  OLO_SUBMIT_TO_APPROVALS,
  REJECT_FROM_PEER_REVIEW,
  APPROVED_FROM_APPROVALS,
  REJECTED_FROM_APPROVALS,
  getFowardTransition,
  getBackwardTransition,
  shouldStatusTransitionSkipPostCrq,
  CLOSED,
  REVOKE_APPROVAL,
};
